import { useFirestoreDocumentMutation } from '@react-query-firebase/firestore';
import React, {useEffect, useState} from 'react'
import { firestore } from '../../firebase';
import {
	collection,
	doc,
} from "firebase/firestore";

const InputGallery = ({className, admin, board}) => {
  const type = className === "headingTitle" ? "title" : "subtitle";

  const [value, onChange] = useState(board?.data?.[type]);

  const collectionRef = collection(firestore, 'boards');
  const ref = doc(collectionRef, board?.data?.id);
  const mutationMerge = useFirestoreDocumentMutation(ref, {
		merge: true,
  });
  useEffect(() => {
      if (admin && value !== board?.data?.[type] && value) {
          console.log("mutate");
          mutationMerge.mutate({
              [type]: value
          });
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[value]);

  useEffect(() => {
      if (board?.data?.id) {
          onChange(board?.data?.[type] || type);
      }
  }, [board?.data?.id])

  if (!board?.data?.id) {
      return null;
  }
  return (
    <input 
        disabled={!admin}
        type="text"
        maxLength={type === 'title' ? 19 : 28}
        value={value}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        className={className}
    />
  )
}

export default InputGallery